/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  //console.log(new Date().toLocaleDateString("en-CA"));
  var checkFinancialV2 = function checkFinancialV2() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/ledgerV2.php?action=get&AccountNumber=' + localStorage.getItem("AccountNumber") + "&Email=" + localStorage.getItem("Email"),
      success: function success(data) {
        var financialCard = "";
        console.log("Output:" + data);
        data = JSON.parse(data);

        for (var i = 0; i < data.record.length; i++) {
          var debit = "";
          var credit = "";
          var color = "";

          if (data.record[i].Amount > 0) {
            debit = "$" + parseFloat(data.record[i].Amount).toFixed(2);
            color = "up";
          } else {
            credit = "$" + parseFloat(data.record[i].Amount).toFixed(2);
            color = "down";
          }

          if (data.record[i].Code == "B001" || data.record[i].Code == "B002") {
            if (parseFloat(data.record[i].Amount).toFixed(2) > 0) {
              debit = "$" + parseFloat(data.record[i].Amount).toFixed(2);
              credit = "";
              color = "right";
            } else {
              credit = "$" + parseFloat(data.record[i].Amount).toFixed(2);
              debit = "";
              color = "right";
            }
          }

          var arr = data.record[i].DateTime.split(" ");
          financialCard += "\n          <tr>\n            <td class=\"label-cell\"><span style=\"font-size:10px;color:gray\">" + arr[0] + "<BR/>" + arr[1] + arr[2] + "</span></td>\n            <td class=\"label-cell\"><span style=\"font-size:10px;\"><img src=\"static/images/arrow-" + color + ".png\" style=\"width:20px;vertical-align:middle\"/> " + data.record[i].Description + "</span></td>\n            <td class=\"numeric-cell\" style=\"text-align:center;color:greenyellow;font-size:12px;\">" + debit + "</td>\n            <td class=\"numeric-cell\" style=\"color:#FF3737;font-size:12px;\">" + credit + "</td>\n          </tr>\n\n          ";
        }

        $(".financial-profit").html("US$" + data.own_profit);
        $(".financial-lot-price").html("US$" + data.own_lot_price);
        $(".financial-lot").html(data.own_lot);
        $(".financial-broker").html("US$" + parseFloat(data.profit_broker * -1));
        $(".financial-robot").html("US$" + parseFloat(data.profit_robotfx * -1));
        $(".financial-deductable").html("US$" + data.deductable);
        $(".financial-deductable-broker").html("US$" + parseFloat(data.deductable * 0.33).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $(".financial-deductable-robotfx").html("US$" + parseFloat(data.deductable * 0.66).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $(".financial-deductable-myr").html("RM" + (data.deductable * window.rate).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $(".financial-total-fund").html("US$" + data.total_fund);
        $(".financial-total-lot").html(data.total_lot + " Lots");
        $(".financial-stock").html(data.AccountName);
        $(".financial-deposit").html("US$" + data.own_deposit);
        $(".financial-withdraw").html("US$" + data.own_withdraw);
        $(".financial-balance").html("US$" + data.AccountBalance);
        $(".financial-stock-price").html("US$" + data.stock_price);
        $(".financial-percent").html(data.own_percent + "%");
        $f7.progressbar.set('.financial-percent-bar', parseFloat(data.own_percent));
        $(".content-financial").html(financialCard);
      }
    });
  };

  $on('pageInit', function () {
    checkFinancialV2();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">

      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Financial Report</div>

    </div>
  </div>
  <div class="page-content"  style="background: linear-gradient(45deg, #121212 0%, #121212 100%);">
  <div class="control-size">  
    <div class="card data-table" style="margin: 0px;background-color: #151924;">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Investor</th>
            <th class="numeric-cell">Amount</th>
          </tr>
        </thead>
        <tbody>

          <tr>
            <td class="label-cell">Investment Value</td>
            <td class="numeric-cell financial-lot-price" style="color:greenyellow;font-weight: 500;font-size:larger;">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell">Deposit</td>
            <td class="numeric-cell financial-deposit" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell">Withdraw</td>
            <td class="numeric-cell financial-withdraw" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell">Own Lot</td>
            <td class="numeric-cell financial-lot" style="color:greenyellow;font-weight: 500;font-size:larger;">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell">Net Profit</td>
            <td class="numeric-cell financial-profit" style="color:greenyellow;">$0.00</td>
          </tr>

          <tr>
            <td class="label-cell">Capital Return</td>
            <td class="numeric-cell financial-percent" style="color:greenyellow;">0%</td>
          </tr>
          <tr>
            <td colspan="2"><span class="progressbar financial-percent-bar color-green" data-progress="0" style="height:10px;"></span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>
    <div class="card data-table" style="margin: 0px;background-color: #151924;">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Stock</th>
            <th class="numeric-cell">Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">Stock Name</td>
            <td class="numeric-cell financial-stock" style="color:white;"></td>
          </tr>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">Stock price per lot</td>
            <td class="numeric-cell financial-stock-price" style="color:white;">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">Total Investment</td>
            <td class="numeric-cell financial-total-fund" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color:  gray;font-size: smaller;">Total Lot</td>
            <td class="numeric-cell financial-total-lot" style="color:gray">0 Lot</td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>
    <div class="card data-table" style="margin: 0px;background-color: #151924;">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Commission</th>
            <th class="numeric-cell">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">Total Balance</td>
            <td class="numeric-cell financial-balance" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color:  gray;font-size: smaller;">Broker Total Fee</td>
            <td class="numeric-cell financial-broker" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color:  gray;font-size: smaller;">Robot Total Fee</td>
            <td class="numeric-cell financial-robot" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">To Pay Broker</td>
            <td class="numeric-cell financial-deductable-broker" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">To Pay RobotFX</td>
            <td class="numeric-cell financial-deductable-robotfx" style="color:gray">$0.00</td>
          </tr>
          <tr>
            <td class="label-cell" style="color: gray;font-size: smaller;">To Pay From Investment <br/> <span style="font-size:14px;color:gray" class="financial-deductable-myr"></span></td>
            <td class="numeric-cell financial-deductable" style="color:orange;font-weight: 500;">$0.00</td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>
    <div class="card data-table" style="margin: 0px;background-color: #151924;">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Time</th>
            <th class="label-cell">Description</th>
            <th class="numeric-cell">Debit</th>
            <th class="numeric-cell">Credit</th>
          </tr>
        </thead>
        <tbody class="content-financial">
          <tr>
            <td class="label-cell">Loading...</td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>

  </div>  
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '631c22131b';
export default framework7Component;